<template>
  <li class="user-menu-item">
    <a
      :href="href"
      @click="navigate"
      v-bind="$attrs"
    >
      <span class="icon" v-if="icon">
        <ion-icon :name="icon"></ion-icon>
      </span>
      <span><slot></slot></span>
    </a>
  </li>
</template>

<script>
export default {
  name: 'UserMenuItem',

  props: {
    href: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
      default: '',
    },
  },

  methods: {
    /**
     * Navigate the url
     *
     * @param e
     */
    navigate(e) {
      this.$emit('click', e);
    },
  },
};
</script>

<style lang="scss" scoped>
  .user-menu-item {
    display: flex;
    align-items: center;
    background: transparent;
    width: 100%;
    max-width: 100%;
    outline: none;
    border: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 10px;
    text-align: left;
    text-decoration: none;
    position: relative;
    font-size: 0.75rem;

    > a {
      @apply text-secondary-700;
      letter-spacing: 0.05em;
      font-size: 0.75rem;
      width: 100%;

      > .icon {
        @apply text-secondary-700;
        margin-right: 5px;
        vertical-align: middle;
        min-height: 16px;
        font-size: 16px;
        line-height: 16px;
      }
    }

    &:hover {
      > a {
        @apply text-primary-600;

        > .icon {
          @apply text-primary-600;
        }
      }
    }
  }
</style>
